import React from "react";
import { styled } from "@mui/material/styles";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const BorderlessTextField = styled(TextField)(({ iconColor, width }) => ({
  width,
  ".dark-theme & .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
  },
  "& fieldset": {
    border: "none !important",
  },
  "&:hover fieldset": {
    border: "none !important",
  },
  "&.Mui-focused fieldset": {
    border: "none !important",
  },
  "& .MuiInputBase-input": {
    color: iconColor,
  },
  "& .MuiInputBase-root": {
    border: "none !important",
    backgroundColor: "transparent",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
  },
}));

function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
  width = 240,
  iconColor = "#605DFF",
}) {
  return (
    <BorderlessTextField
      placeholder={placeholder}
      variant="outlined"
      size="small"
      value={value}
      onChange={onChange}
      iconColor={iconColor}
      width={width}
      className="bg-f6f7f9"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon sx={{ color: iconColor }} />
          </InputAdornment>
        ),
      }}
    />
  );
}

export default SearchInput;
